/* eslint-disable no-case-declarations */
/* eslint-disable no-param-reassign */
import { createSelector } from 'reselect';

import {
  updateActivitiesRcnAdd,
  updateActivitiesRcnRemove
} from 'utils/objectives.utils';
import { actions as objectiveActions } from 'containers/Objective/store/actions';
import { actions as headerActions } from 'containers/Header/store/actions';
import { actions as appActions } from 'containers/App/store/actions';
import actions from './actions';

const initialState = {
  objectiveActivities: null,
  inFocusCommentId: null,
  user_reaction_details: null,
  recentReactionAssociationId: null,
  jira: {
    jiraConnections: null,
    userConnections: null,
    nonUserConnections: null,
    jiraIssues: null,
    jiraLabels: null,
    connectionsRequestStatus: 0,
    createConnectionRequestStatus: 0,
    queryIssuesRequestStatus: 0,
    deleteProgressTrackerRequestStatus: 0,
    trackProgressWithJiraRequestStatus: 0,
    jiraIntegrationUpdatedProgress: null,
    objectiveDetails: null
  }
};

// Memorized  Selector Function
export const getObjectiveActivitySelector = createSelector(
  state => state.objectiveDetailsReducer.objectiveActivities,
  objectiveActivities => objectiveActivities
);

export const getDashboardInfoSelector = createSelector(
  state => state.objectiveDetailsReducer.dashboardInfo,
  dashboardInfo => dashboardInfo
);

export const getInFocusCommentIdSelector = createSelector(
  state => state.objectiveDetailsReducer.inFocusCommentId,
  inFocusCommentId => inFocusCommentId
);

export const getJiraIntegrationDataSelector = createSelector(
  state => state.objectiveDetailsReducer.jira,
  jira => jira
);

export const getJiraConnectionsSelector = createSelector(
  state => state.objectiveDetailsReducer.jira.jiraConnections,
  jiraConnections => jiraConnections
);

export const getJiraLatestProgressSelector = createSelector(
  state => state.objectiveDetailsReducer.jira.jiraIntegrationUpdatedProgress,
  jiraIntegrationUpdatedProgress => jiraIntegrationUpdatedProgress
);

export const getObjectiveDetailsForJiraIntegrationSelector = createSelector(
  state => state.objectiveDetailsReducer.jira.objectiveDetails,
  objectiveDetails => objectiveDetails
);

export const getUserReactionDetails = createSelector(
  state => state.objectiveDetailsReducer.user_reaction_details,
  user_reaction_details => user_reaction_details
);

export const getRecentReactionAssociationId = createSelector(
  state => state.objectiveDetailsReducer.recentReactionAssociationId,
  recentReactionAssociationId => recentReactionAssociationId
);

export default (state = initialState, payload = {}) => {
  switch (payload.type) {
    case actions.SAVE_OBJECTIVE_ACTIVITIES:
      return {
        ...state,
        objectiveActivities: {
          ...state.objectiveActivities,
          activity_details: payload.responseData.activity_details
        }
      };

    case actions.SAVE_OBJECTIVE_COMMENTS:
      return {
        ...state,
        objectiveActivities: {
          ...state.objectiveActivities,
          comment_details: payload.responseData.comments
        }
      };

    case actions.SAVE_OBJECTIVE_CHECKINS:
      return {
        ...state,
        objectiveActivities: {
          ...state.objectiveActivities,
          check_in_details: payload.responseData.comments
        }
      };

    case actions.SAVE_OBJECTIVE_ACTIVITY_DETAILS:
      return {
        ...state,
        objectiveActivities: {
          activity_details: payload.activity_details,
          comment_details: payload.comment_details,
          check_in_details: payload.check_in_details
        }
      };

    case actions.SAVE_DETAILS_PAGE_DATA:
      return {
        ...state,
        dashboardInfo: payload.metricDashboardData,
        objectiveActivities: {
          activity_details: payload.activityDetails,
          comment_details: payload.commentDetails,
          check_in_details: payload.checkInDetails
        }
      };
    case actions.SAVE_DETAILS_PAGE_DATA_SET1:
      return {
        ...state,
        dashboardInfo: payload.metricDashboardData,
        objectiveActivities: {
          ...state.objectiveActivities,
          check_in_details: payload.checkInDetails
        }
      };

    case actions.SAVE_DETAILS_PAGE_DATA_SET2:
      return {
        ...state,
        objectiveActivities: {
          ...state.objectiveActivities,
          activity_details: payload.activityDetails,
          comment_details: payload.commentDetails
        }
      };

    case actions.SAVE_METRIC_DASHBOARD_INFO:
      return {
        ...state,
        dashboardInfo: payload.data
      };

    case actions.CLEAR_OBJECTIVE_ACTIVITIES:
      return {
        ...state,
        objectiveActivities: null,
        dashboardInfo: null
      };

    case actions.SAVE_FOCUS_COMMENT_ID_ACTION:
      return {
        ...state,
        inFocusCommentId: payload.comment_id
      };

    case actions.SAVE_OBJECTIVE_DETAILS:
      return {
        ...state,
        jira: {
          ...state.jira,
          objectiveDetails: payload.data
        }
      };

    case actions.SAVE_JIRA_CONNECTIONS:
      return {
        ...state,
        jira: {
          ...state.jira,
          jiraConnections: payload.data
        }
      };

    case actions.CONNECTIONS_REQUEST_STATUS:
      return {
        ...state,
        jira: {
          ...state.jira,
          connectionsRequestStatus: payload.status
        }
      };

    case actions.SAVE_USER_JIRA_CONNECTIONS:
      return {
        ...state,
        jira: {
          ...state.jira,
          userConnections: payload.data
        }
      };

    case actions.SAVE_NON_USER_JIRA_CONNECTIONS:
      return {
        ...state,
        jira: {
          ...state.jira,
          nonUserConnections: payload.data
        }
      };

    case actions.SAVE_JIRA_ISSUES:
      return {
        ...state,
        jira: {
          ...state.jira,
          jiraIssues: payload.data
        }
      };

    case actions.SAVE_JIRA_LABELS:
      return {
        ...state,
        jira: {
          ...state.jira,
          jiraLabels: payload.data
        }
      };

    case actions.SAVE_CREATE_CONNECTION_REQUEST_STATUS:
      return {
        ...state,
        jira: {
          ...state.jira,
          createConnectionRequestStatus: payload.status
        }
      };

    case actions.RESET_CREATE_CONNECTION_REQUEST_STATUS:
      return {
        ...state,
        jira: {
          ...state.jira,
          createConnectionRequestStatus: 0
        }
      };

    case actions.SAVE_ISSUES_REQUEST_STATUS:
      return {
        ...state,
        jira: {
          ...state.jira,
          queryIssuesRequestStatus: payload.status
        }
      };

    case actions.DELETE_PROGRESS_TRACKER_REQUEST_STATUS:
      return {
        ...state,
        jira: {
          ...state.jira,
          deleteProgressTrackerRequestStatus: payload.status
        }
      };

    case actions.RESET_ISSUES_REQUEST_STATUS:
      return {
        ...state,
        jira: {
          ...state.jira,
          queryIssuesRequestStatus: 0
        }
      };

    case actions.TRACK_PROGRESS_WITH_JIRA_REQUEST_STATUS:
      return {
        ...state,
        jira: {
          ...state.jira,
          trackProgressWithJiraRequestStatus: payload.status
        }
      };

    case actions.RESET_TRACK_PROGRESS_WITH_JIRA_REQUEST_STATUS:
      return {
        ...state,
        jira: {
          ...state.jira,
          trackProgressWithJiraRequestStatus: 0
        }
      };

    case actions.SAVE_JIRA_INTEGRATION_LATEST_PROGRESS:
      return {
        ...state,
        jira: {
          ...state.jira,
          jiraIntegrationUpdatedProgress:
            payload.data.objective_id ===
              state.jira.jiraIntegrationUpdatedProgress?.objective_id &&
            payload.data?.reset === 'reset'
              ? null
              : payload.data
        }
      };

    case appActions.RESET_REDUCER:
      return {
        ...state,
        objectiveActivities: null
      };

    case actions.SAVE_ADD_REACTION:
      return {
        ...state,
        user_reaction_details: {
          time: new Date().getTime()
        },
        objectiveActivities: updateActivitiesRcnAdd(
          state.objectiveActivities,
          payload.data
        )
      };

    case actions.SAVE_REMOVE_REACTION:
      return {
        ...state,
        user_reaction_details: {
          time: new Date().getTime()
        },
        objectiveActivities: updateActivitiesRcnRemove(
          state.objectiveActivities,
          payload.data
        )
      };

    case actions.SAVE_RECENT_REACTION_ASSOCIATION_ID:
      return {
        ...state,
        recentReactionAssociationId: payload.association_id
      };

    case actions.SAVE_VIEW_IN_CONTEXT_DATA:
      return {
        ...state,
        viewInContextObjective: payload.objective,
        viewInContextSelectedCycle: payload.selectedCycle,
        viewInContextSelectedTab: payload.selectedTab
      };

    case headerActions.SAVE_SELECTED_TEAM:
    case headerActions.SAVE_SELECTED_OBJECTIVE_CYCLE:
    case headerActions.SET_FILTERS:
    case headerActions.SET_DASHBOARD_FILTERS:
    case appActions.ENABLE_SEARCH_ACTION:
    case objectiveActions.CLEAR_ALIGNED_OBJECTIVE:
    case objectiveActions.SET_SELECTED_OBJECTIVE:
      return {
        ...state,
        viewInContextObjective: null,
        viewInContextSelectedCycle: null,
        viewInContextSelectedTab: null
      };

    default:
      return state;
  }
};
